import { render, staticRenderFns } from "./ecommerce.vue?vue&type=template&id=03e1c466&scoped=true&"
import script from "./ecommerce.vue?vue&type=script&lang=js&"
export * from "./ecommerce.vue?vue&type=script&lang=js&"
import style0 from "./ecommerce.vue?vue&type=style&index=0&id=03e1c466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e1c466",
  null
  
)

export default component.exports